import { Component, OnInit } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { svgMenuMap } from '../../helpers/helpers';

@Component({
  selector: 'app-cron-frequency-type',
  templateUrl: './cron-frequency-type.component.html',
  styleUrls: ['./cron-frequency-type.component.scss']
})
export class CronFrequencyTypeComponent extends FieldType implements OnInit {
  generatorIcon = svgMenuMap.generatorIcon;
  closeIcon = svgMenuMap.closeIcon;
  ngOnInit(): void {
  }

}
